import { gql } from '@apollo/client';

export const REQUEST_EMAIL_CONFIRMATION_MUTATION = gql`
  mutation requestEmailConfirmation($email: String!) {
    requestEmailConfirmation(email: $email)
  }
`;

export const CURRENT_USER_EMAIL_CONFIRMED_QUERY = gql`
  query currentUserEmailConfirmedQuery {
    currentUser {
      emailConfirmed
    }
  }
`;

export const CONFIRM_USER_EMAIL_MUTATION = gql`
  mutation confirmUserEmail($token: String!) {
    confirmEmail(token: $token) {
      id
      email
      emailConfirmed
    }
  }
`;
